import React, {Component, useEffect, useState} from 'react'

import ChangingProgressProvider from "./ChangingProgressProvider";
import {buildStyles, CircularProgressbar} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import {bemClassName} from 'bem-components-connector'

import './style.scss'

import Preloader from './img/preloader.svg'

import Slider from "react-slick";

export const startRandomProgress = (finishCallback = () => true, condition = true, timeout = 80, step = 1) => {

    const [progress, setProgress] = useState(0)

    useEffect(() => {

        let isProgressNotFinish = progress !== 100

        if (isProgressNotFinish) {

            let incrementNumber = Math.round(Math.random() * 3) + step,
                incrementedNumber = progress + incrementNumber,
                isProgressFinish = incrementedNumber >= 99

            if (isProgressFinish) incrementedNumber = 100

            setTimeout(() => {

                if (isProgressFinish) finishCallback()

                setProgress(incrementedNumber)
            },timeout);

        }


    }, [progress])


    return progress
}

export const startRandomProgressEveryCall = (finishCallback = () => true, everyCallback = () => true, timeout = 80, step = 1) => {

    const [progress, setProgress] = useState(0)

    useEffect(() => {

        let isProgressNotFinish = progress !== 100

        if (isProgressNotFinish) {

            let incrementNumber = Math.round(Math.random() * 3) + step,
                incrementedNumber = progress + incrementNumber,
                isProgressFinish = incrementedNumber >= 99,
                everyCallResult = everyCallback(progress)

            if (isProgressFinish) incrementedNumber = 100

            if (everyCallResult === true) {

                setTimeout(() => {

                    if (isProgressFinish) finishCallback()

                    setProgress(incrementedNumber)
                },timeout);

            }



        }


    }, [progress])


    return [progress,setProgress]

}

export const startRandomProgressConditions = (conditions = false, finishCallback = () => true, timeout = 80) => {

    const [progress, setProgress] = useState(0)

    useEffect(() => {

        let isProgressNotFinish = progress !== 100

        if (isProgressNotFinish) {

            let incrementNumber = Math.round(Math.random() * 3) + 1,
                incrementedNumber = progress + incrementNumber,
                isProgressFinish = incrementedNumber >= 99

            if (isProgressFinish) incrementedNumber = 100

            if (conditions === true) {

                setTimeout(() => {

                    if (isProgressFinish) finishCallback()

                    setProgress(incrementedNumber)
                },timeout);

            }



        }


    }, [progress])


    return [progress,setProgress]

}


export const Progressbar = ({progress = 0, list, timeout = 300, speed = 300, onFinish}) => {

    const block = bemClassName('progress-bar'),
          settings = {
            dots: false,
            infinite: false,
            arrows: false,
            autoplay: true,
            fade: true,
            speed: speed,
            autoplaySpeed: timeout,
            slidesToShow: 1,
            slidesToScroll: 1,
    };

    const slides = list.map((item, key) =>
        (<div key={key} className={block('slide-item')}><span>{item}</span></div>)
    )



    return (<div className={block()}>

        <div className={block('line')} style={{transform: `translateX(${progress}%)`}} />

        <div className={block('content')} >
            {progress === 100 ? <span className={block('ready')}>Готово</span> : <>
                <img src={Preloader} alt="preloader"/>

                <div className={block('slider-wrapper')} >
                    <Slider key={'progress-tit'} {...settings}>
                        {slides}
                    </Slider>
                </div>
            </>}







        </div>

    </div>)
}

export const ProgressbarLtr = ({text, progress = 0}) => {

    const block = bemClassName('progress-bar')

    return (<div className={block()}>

        <div className={block('line')} style={{transform: `translateX(${progress}%)`}} />

            <div className={block('content', {flex: true})} >

                <div className={block('text-wrapper')}>
                    <span>{text}</span>
                    {progress > 0 && progress < 100 ? <img src={Preloader} alt="preloader"/> : null}

                </div>
                <span className={block('progress')}>
                    <b>
                        {progress}%
                    </b>
                </span>


            </div>


        </div>
        )

}


export class ProgressBarCircle extends Component {
    render() {
        return (
            <div className="progress__circle">
                <ChangingProgressProvider
                    isActive={this.props.isActive}
                    repeat={false}
                    time={8}
                    repeat={false}
                    isOnAnimation={this.props.isOnAnimation}
                    onAnimationFinish={this.props.onAnimationFinish}
                >
                    {(percentage) => (
                        <CircularProgressbar
                            isOnAnimation={this.props.isOnAnimation}
                            value={percentage}
                            // text={`${percentage}%`}
                            strokeWidth="2"
                            styles={buildStyles({
                                pathTransitionDuration: 0.15,
                                pathColor: "#F62C84",
                                trailColor: "transparent",
                            })}
                        />
                    )}
                </ChangingProgressProvider>
            </div>
        );
    }
}
